export default __webpack_public_path__ + "static/media/avatar-profile.109271ce.svg";